import { bffInstance } from "../api/axiosInstance";
import {
  useQuery,
} from "react-query";
import useCampaignStore from "./CampaignStore";
import userProfileStore from "../core/UserProfileStore";
import {useApplicationStore} from "../home/ApplicationStore";

export interface UserProfile {
  firstName: string;
  lastName: string;
  mobilePhone: string;
  email: string;
  locale?: string;
  enterpriseId?: string;
  defaultStore?: string;
}

export interface UserInfo {
  profile?: UserProfile;
  lastLogin?: Date;
}

export interface CampaignsResponse {
  id: string;
  logo: any;
  darkLogo: any;
  name: string;
  description: string;
  link?: string;
  linkText: string;
  showLogo: boolean;
}

export const fetchUnifyCampaign = async (locale: string, applications: string[], workflows: string[], enterpriseId: string, stores: string[]) => {

  const requestBody = {
    applications,
    workflows,
    enterpriseId,
    stores
  };

  const userLocaleS = localStorage.getItem("userLocale") ?? "en_US";

  const res = await bffInstance.post<CampaignsResponse[]>('/getCampaignsForHome',requestBody,{
    headers:{
      'Accept-Language': userLocaleS
    }
  });
  return res.data;
};

export function useCampaign() {

  const {setCampaigns} = useCampaignStore();
  const {applications} = useApplicationStore();
  const appIds = applications?.map((app: any) => app.id) || [];
  const userProfile = userProfileStore();
  const workflowIds = applications?.flatMap((app: any) => app?.workflows?.map((workflow: any) => workflow?.workflowId)) || [];
  const storeIds = userProfile?.iamUserProfile?.fullUser?.stores.map((store: any ) => store.id) || [];
  const locale = localStorage.getItem("userLocale") ?? "en_US";

  const campaign = useQuery({
    queryKey: ["getCampaignsForHome"],
    queryFn: () => fetchUnifyCampaign(locale, 
        appIds,
        workflowIds, 
        userProfile?.enterpriseId, storeIds),
    onSuccess(data) {
      setCampaigns(data);
    },
    enabled: !!userProfile?.enterpriseId && !!applications?.length
  });
  return campaign;
}

